export const toNumber = (decimal: number | string) => {
  return typeof decimal === 'string' ? parseFloat(decimal) : decimal;
};
